import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroCarousel from "./components/HeroCarousel";
import CategoryIconStrip from "./components/CategoryIconStrip";
import ProductCategories from "./components/ProductCategories";
import Information from "./components/Information";
import AboutStats from "./components/AboutStats";
import PartnersStrip from "./components/PartnersStrip";
import SupportSection from "./components/SupportSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import ProductPage from "./pages/ProductPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import SupportPage from "./pages/SupportPage";
import SejarahPage from "./pages/SejarahPage";
import KontakPage from "./pages/KontakPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PWAInstallBanner from "./components/PWAInstallBanner";
import WhatsAppBubble from "./components/WhatsAppBubble";
import GoogleAnalytics from "./components/GoogleAnalytics";
import SEO from "./components/SEO";
import { AuthProvider } from "./context/AuthContext";
import { SiteContentProvider } from "./context/SiteContentContext";

const Home = () => {
  return (
    <>
      <SEO path="/" pageName="Beranda" />
      <Header />
      <main data-testid="home-page">
        <HeroCarousel />
        <CategoryIconStrip />
        <ProductCategories />
        <AboutStats />
        <Information />
        <SupportSection />
        <PartnersStrip />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteContentProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
              <Route path="/produk" element={<ProductPage />} />
              <Route path="/produk/:categorySlug" element={<ProductPage />} />
              <Route path="/produk/:categorySlug/:subcategorySlug" element={<ProductPage />} />
              <Route path="/produk/detail/:productId" element={<ProductDetailPage />} />
              <Route path="/dukungan" element={<SupportPage />} />
              <Route path="/sejarah" element={<SejarahPage />} />
              <Route path="/kontak" element={<KontakPage />} />
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <PWAInstallBanner />
            <WhatsAppBubble />
            <GoogleAnalytics />
          </SiteContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
